import React from "react";

interface FormCardProps {
  /**
   * Optional section title
   */
  title?: string;

  /**
   * Optional helper text shown below the title
   */
  subtitle?: string;

  /**
   * Optional actions displayed on the right
   */
  actions?: React.ReactNode;

  /**
   * Form content
   */
  children: React.ReactNode;

  className?: string;
}

export default function FormCard({
  title,
  subtitle,
  actions,
  children,
  className = "",
}: FormCardProps) {
  return (
    <section
      className={`
        rounded-2xl
        border
        border-slate-200
        bg-white
        shadow-sm
        ${className}
      `}
    >
      {(title || subtitle || actions) && (
        <div
          className="
            flex
            flex-col
            gap-4
            border-b
            border-slate-100
            px-6
            py-5

            sm:flex-row
            sm:items-start
            sm:justify-between
          "
        >
          <div className="min-w-0">

            {title && (
              <h2 className="text-lg font-semibold text-slate-900">
                {title}
              </h2>
            )}

            {subtitle && (
              <p className="mt-1 text-sm text-slate-500">
                {subtitle}
              </p>
            )}

          </div>

          {actions && (
            <div className="flex-shrink-0">
              {actions}
            </div>
          )}
        </div>
      )}

      <div className="p-6">
        {children}
      </div>
    </section>
  );
}